import { styled } from '@mui/material/styles';
import { OutlinedPushPin } from 'icons';

export const selectionPinButtonClasses = {
  outlinedIcon: 'SelectionPinButton-outlinedIcon',
};

export const SelectionPinButtonOutlinedIcon = styled(OutlinedPushPin)({
  opacity: 0,
  transition: 'opacity 0.2s ease-in-out',
});
